export default __webpack_public_path__ + "static/media/todo-screenshot-06.faadc23a.png";